<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
   
      
    <!--Datum  izveštaja za Plaćanje računa-->
      
            <div class="form-group row">
                <div class="col-md-12">
                  <yt-fw-date-picker-popup
                    formControlName="Datum"
                    name="txtDatum" 
                    [Label]="'PLACANJERACUNA.DATUM.SINGULAR'">                    
                  </yt-fw-date-picker-popup>

                  <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                  <span *ngFor="let validation of errorMessages.Datum">
                    <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)">
                      <span [ngClass]="{'slideInRight': fc.Datum.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                      </span>
                    </span>
                  </span>
                  </div>
                </div>
            </div>
                 
      
    <!--Broj transakcije-->
           
                  
                        <div class="form-group row">   
                            <label class="col-form-label col-md-6">
                            <span translate="PLACANJERACUNA.BRTRANS.SINGULAR"></span>
                            </label> 

                            <div class="col-md-6">                         
                                <yt-number-input-v2
                                formControlName="BrTrans"
                                name="txtBRTRANS">
                              </yt-number-input-v2>
                                <div class="form-error" *ngIf="submitted && fc.BrTrans.invalid">
                                    <span *ngFor="let validation of errorMessages.BrTrans">
                                      <span class="error-message" *ngIf="fc.BrTrans.hasError(validation.type)">
                                        <span [ngClass]="{'slideInRight': fc.BrTrans.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                                        </span>
                                      </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                  
        
    
    <!--Ukupno Dnevni promet-->

                <div class="form-group row">
                    <label class="col-form-label col-md-6">
                    <span translate="PLACANJERACUNA.UKUPNODNEVNIPROMET.SINGULAR"></span>
                    </label>          
                    <div class="col-md-6">                
                        <yt-number-input-v2
                        formControlName="UkupnoDnevniPromet"
                        name="txtUKUPNODNEVNIPROMET">
                      </yt-number-input-v2> 
                        <div class="form-error" *ngIf="submitted && fc.UkupnoDnevniPromet.invalid">
                            <span *ngFor="let validation of errorMessages.UkupnoDnevniPromet">
                              <span class="error-message" *ngIf="fc.UkupnoDnevniPromet.hasError(validation.type)">
                                <span [ngClass]="{'slideInRight': fc.UkupnoDnevniPromet.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                                </span>
                              </span>
                            </span>
                        </div>
                    </div>
                </div>
   
      
    <!--Ukupno PROVIZIJA-->

                    <div class="form-group row">
                        <label class="col-form-label col-md-6">
                        <span translate="PLACANJERACUNA.UKUPNOPROVIZIJA.SINGULAR"></span>
                        </label>          
                        <div class="col-md-6">                     
                            <yt-number-input-v2
                            formControlName="UkupnoProvizija"
                            name="txtUKUPNOPROVIZIJA">
                          </yt-number-input-v2> 
                            <div class="form-error" *ngIf="submitted && fc.UkupnoProvizija.invalid">
                                <span *ngFor="let validation of errorMessages.UkupnoProvizija">
                                  <span class="error-message" *ngIf="fc.UkupnoProvizija.hasError(validation.type)">
                                    <span [ngClass]="{'slideInRight': fc.UkupnoProvizija.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                                    </span>
                                  </span>
                                </span>
                            </div>
                        </div>
                    </div>
    </div>
    </form>
      
      